import { render, staticRenderFns } from "./QuestionNavigation_variant2.vue?vue&type=template&id=26b8c8ea&scoped=true"
import script from "./QuestionNavigation_variant2.vue?vue&type=script&lang=js"
export * from "./QuestionNavigation_variant2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b8c8ea",
  null
  
)

export default component.exports